import { useNavigate } from 'react-router';
import SearchIcon from '@mui/icons-material/Search';

import { getButtonLinkProps, ROUTES } from '@openclassrooms/routing';
import { getActiveLocale, translate } from '@openclassrooms/translations';
import browser from '@openclassrooms/utils/browser';
import { localStorage } from '@openclassrooms/utils/local-storage';

import { styled } from '@classify/react-core-components/styles';

const SearchLink = styled('button')(({ theme: { spacing, palette } }) => ({
  display: 'flex',
  border: 'none',
  background: 'none',
  padding: 0,
  marginLeft: 'auto',
  marginRight: spacing(1),
  alignContent: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  '& svg': {
    width: 32,
    height: 32,
    color: palette.text.onMain,
  },
  '&:hover': {
    '& svg': {
      color: palette.primary.main,
    },
  },
}));

const SearchButton = () => {
  const { window } = browser;
  const navigate = useNavigate();
  const isUrlLegacy = getButtonLinkProps(ROUTES.SEARCH.INDEX).component === 'a';

  async function handleClick(event: React.MouseEvent) {
    event.preventDefault();
    await localStorage.setItem('searchPageOriginUrl', window.location.href);

    if (isUrlLegacy) {
      window.location.href = `/${getActiveLocale()}${ROUTES.SEARCH.INDEX}`;
    } else {
      navigate(ROUTES.SEARCH.INDEX);
    }
  }

  return (
    <SearchLink
      id="main-search"
      tabindex={0}
      onClick={handleClick}
      title={translate('global.hover.search')}
      aria-label={translate('global.word.search')}
    >
      <SearchIcon />
    </SearchLink>
  );
};

export default SearchButton;
